import React, { Component } from 'react';
import { SingleFeatures1 } from './SingleFeatures1';

export class Features1 extends Component {
    static displayName = Features1.name;

    constructor(props) {
        super(props);
        this.state = {
            componentId: props.componentId,
            features1: null
        };
    }

    componentDidMount() {
        this.getComponentData();
    }

    render() {
        let features = [];
        if (this.state.features1 != null) {
            let singleFeatures1Ids = this.state.features1.singleFeatures1IdList.split(',');
            for (var i = 0; i < singleFeatures1Ids.length; i++) {
                features.push(<SingleFeatures1 componentId={singleFeatures1Ids[i]} />);
            }
        }

        return (
            <div className="content-wrapper feature-area-padding">
                <div className="grid-thirds feature-thirds">
                    {features}
                </div>
            </div>
        );
    }

    async getComponentData() {
        const response = await fetch('Components/GetFeatures1?componentId=' + this.state.componentId, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });

        const data = await response.json();

        if (data != null) {
            this.setState({
                features1: data
            });
        }
    }
}